import { Review, ReviewTextKey, reviews } from './reviews.config';

export type Testimonial = Review;
export type TestimonialTextKey = ReviewTextKey;

const testimonialIds = ['testimonial-1', 'testimonial-4', 'testimonial-8', 'testimonial-3', 'testimonial-5'];

export const testimonials: Testimonial[] = reviews.filter(review => testimonialIds.includes(review.id));
